import classNames from 'classnames';
import { type TestId } from '@repo/test-id';
import { tr } from '@repo/locale';

interface Props {
  testId: TestId;
  showTextLine1: boolean;
  showTextLine2: boolean;
  showUnderline: boolean;
}

export default function TextAnimation({ testId, showTextLine1, showTextLine2, showUnderline }: Props) {
  return (
    <div className="flex flex-col items-center justify-center">
      <div className="relative text-center">
        <h1 className="font-sans text-2xl leading-[150%] text-white">
          <span
            data-testid={testId.append('textLine1')}
            className={classNames('block font-normal transition-all duration-700', {
              'translate-y-0 opacity-100': showTextLine1,
              'translate-y-4 opacity-0': !showTextLine1,
            })}
          >
            {tr('splash_screen:text_line_1')}
          </span>

          <span
            data-testid={testId.append('textLine2')}
            className={classNames('relative font-semibold transition-all duration-700', {
              'translate-y-0 opacity-100': showTextLine2,
              'translate-y-4 opacity-0': !showTextLine2,
            })}
          >
            {tr('splash_screen:text_line_2')}
            <span
              data-testid={testId.append('underline')}
              className={classNames('absolute -bottom-2 left-0 overflow-hidden transition-all duration-700', {
                'w-full': showUnderline,
                'w-0': !showUnderline,
              })}
            >
              <svg className="w-full" viewBox="0 0 240 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
                <path
                  d="M2 10C80 2 160 2 238 10"
                  stroke="var(--color-splash-screen-accent)"
                  strokeWidth="4"
                  strokeLinecap="round"
                />
              </svg>
            </span>
          </span>
        </h1>
      </div>
    </div>
  );
}
